export default "__VITE_ASSET__r2g5GU1q__"